import { useNavigate } from "@tanstack/react-router";

import { isMessageLoadedInVirtualizedList } from "@/react/components/Chat/EmbeddableChat/VirtualizedMessageList/loadedMessageScrollers";

import { scrollToMessage } from "../../helpers";

export const useRedirectToMessage = () => {
  const navigate = useNavigate();

  const redirectToMessage = (message: any) => {
    const { id, parent_message_id: parentMessageId } = message;

    if (parentMessageId) {
      void navigate({
        to: ".",
        search: { message_id: id },
        hash: `message_${parentMessageId}`,
      });
    } else {
      void navigate({
        to: ".",
        hash: `message_${id}`,
      });
    }
  };

  const handlePinnedMessage = (message: any) => {
    const messageElement = document.getElementById(message.id);

    // Loaded in a virtualized list, but not mounted because it's out of view.
    if (
      messageElement ||
      isMessageLoadedInVirtualizedList(String(message.id))
    ) {
      scrollToMessage(message.id);
    } else {
      redirectToMessage(message);
    }
  };

  return { redirectToMessage, handlePinnedMessage };
};
